export default __webpack_public_path__ + "static/media/table.353df71d.jpg";